/* global google */
import React, { Component } from 'react'

import loadScript from '../../load-script'

import './LBUMap.css'

class LBUMap extends Component {

    componentDidMount() {
        const [ lng, lat ] = this.props.location

        loadScript(`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}`).then(() => {
            this.map = new google.maps.Map(this.mapDiv, {
                center: {lng, lat},
                zoom: 15
            })
            this.marker = new google.maps.Marker({
                position: {lng, lat},
                map: this.map,
                draggable: true
            })
            this.marker.addListener('dragend', (e) => {
                const lat = Math.round(e.latLng.lat() * 1e6) / 1e6
                const lng = Math.round(e.latLng.lng() * 1e6) / 1e6
                this.props.onChange([lng, lat])
            })
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            const [ lng, lat ] = this.props.location
            this.marker.setPosition({ lng, lat })
            this.map.panTo({ lng, lat })
        }
    }

    render() {
        return (
          <div
            className="LBUMap"
            ref={div => { this.mapDiv = div }} />
        )
    }
}

export default LBUMap



// WEBPACK FOOTER //
// ./src/components/LBUs/LBUMap.js